import { render, staticRenderFns } from "./orderWxshenpi.vue?vue&type=template&id=cc094012&scoped=true"
import script from "./orderWxshenpi.vue?vue&type=script&lang=js"
export * from "./orderWxshenpi.vue?vue&type=script&lang=js"
import style0 from "./orderWxshenpi.vue?vue&type=style&index=0&id=cc094012&prod&scoped=true&lang=css"
import style1 from "./orderWxshenpi.vue?vue&type=style&index=1&id=cc094012&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc094012",
  null
  
)

export default component.exports